export const administracionRoutes = [
  {
    path: '/administracion',
    name: 'Administracion',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiTune',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Administracion',
      requiresSession: true,
      perfiles: ['ADMINISTRACION', 'CONTRATACION'],
      permiso: []
    },
    children: [
      {
        path: '/kioscos',
        name: 'KioscosAutoadmision',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Kioscos/KioscosIndex.vue'
          ),
        icon: 'mdiMonitorDashboard',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Kioscos',
          requiresSession: true,
          permiso: [],
          perfiles: ['ADMINISTRACION', 'ADMISIONES', 'ADMIN_KIOSCO'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/pantallas',
        name: 'PantallasSalaEspera',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Pantalla/views/PantallasIndex.vue'
          ),
        icon: 'mdiTelevision',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Pantallas',
          requiresSession: true,
          permiso: [],
          perfiles: ['ADMINISTRACION', 'ADMISIONES', 'ADMIN_KIOSCO'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/contratacion',
        name: 'Contratacion',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Core/views/Index.vue'
          ),
        icon: 'ClipboardDocumentListIcon',
        menu: true,
        desplegable: true,
        meta: {
          title: 'Contratación entidades',
          requiresSession: true,
          perfiles: ['CONTRATACION'],
          permiso: []
        },
        children: [
          {
            path: '/empresas',
            name: 'Empresas',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Empresas/EmpresasIndex.vue'
              ),
            icon: 'BuildingOffice2Icon',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Empresas',
              requiresSession: true,
              permiso: [],
              perfiles: ['ADMINISTRACION'],
              showBackButton: false
            },
            children: []
          },
          {
            path: '/empresas/create',
            name: 'EmpresasCreate',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Empresas/EmpresasForm.vue'
              ),
            icon: 'BuildingOffice2Icon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Registrar empresa',
              requiresSession: true,
              permiso: []
            },
            children: []
          },
          {
            path: '/empresas/create/:id',
            name: 'EmpresasUpdate',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Empresas/EmpresasForm.vue'
              ),
            icon: 'BuildingOffice2Icon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Actualizar empresa',
              requiresSession: true,
              permiso: []
            },
            children: []
          },
          {
            path: '/cups',
            name: 'Cups',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Cups/CupsIndex.vue'
              ),
            icon: 'QueueListIcon',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Cups',
              requiresSession: true,
              perfiles: ['CONTRATACION'],
              permiso: [],
              showBackButton: false
            },
            children: []
          },
          {
            path: '/cups/create',
            name: 'CupsCreate',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Cups/CupsForm.vue'
              ),
            icon: 'ClipboardDocumentListIcon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Crear CUPS',
              requiresSession: true,
              perfiles: ['CONTRATACION'],
              permiso: []
            },
            children: []
          },
          {
            path: '/cups/create/:id',
            name: 'CupsUpdate',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Cups/CupsForm.vue'
              ),
            icon: 'ClipboardDocumentListIcon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Actualizar CUPS',
              requiresSession: true,
              perfiles: ['CONTRATACION'],
              permiso: []
            },
            children: []
          },
          {
            path: '/servicios',
            name: 'Servicios',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Servicios/ServicioIndex.vue'
              ),
            icon: 'BuildingStorefrontIcon',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Servicios',
              requiresSession: true,
              permiso: [],
              perfiles: ['CONTRATACION'],
              showBackButton: false
            },
            children: []
          },
          {
            path: '/servicios/form',
            name: 'ServiciosCreate',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Servicios/ServicioForm.vue'
              ),
            icon: 'BuildingStorefrontIcon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Crear Servicios',
              requiresSession: true,
              perfiles: ['CONTRATACION'],
              permiso: []
            },
            children: []
          },
          {
            path: '/servicios/form/:id',
            name: 'ServiciosUpdate',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Servicios/ServicioForm.vue'
              ),
            icon: 'BuildingStorefrontIcon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Actualizar Servicios',
              requiresSession: true,
              permiso: []
            },
            children: []
          },
          {
            path: '/contratos',
            name: 'Contratos',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Contratos/ContratosIndex.vue'
              ),
            icon: 'ClipboardDocumentListIcon',
            menu: true,
            desplegable: false,
            meta: {
              title: 'Contratos',
              requiresSession: true,
              permiso: [],
              perfiles: ['CONTRATACION'],
              showBackButton: false
            },
            children: []
          },
          {
            path: '/contratos/create',
            name: 'ContratoCreate',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Contratos/ContratosForm.vue'
              ),
            icon: 'ClipboardDocumentListIcon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Registrar contrato',
              requiresSession: true,
              perfiles: ['CONTRATACION'],
              permiso: []
            },
            children: []
          },

          {
            path: '/contratos/create/:id',
            name: 'ContratoUpdate',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Contratos/ContratosForm.vue'
              ),
            icon: 'ClipboardDocumentListIcon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Actualizar contrato',
              requiresSession: true,
              perfiles: ['CONTRATACION'],
              permiso: []
            },
            children: []
          },
          {
            path: '/contratos/portafolio/:id',
            name: 'Portafolio',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Contratos/Portafolio/PortafolioIndex.vue'
              ),
            icon: 'ClipboardDocumentListIcon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Portafolio',
              subTitle: 'Portafolio de servicios',
              requiresSession: true,
              showBackButton: false,
              permiso: []
            },
            children: []
          },
          {
            path: '/contratos/metas/:id',
            name: 'Metas',
            component: () =>
              import(
                /* webpackChunkName: "administracion" */ '@/modules/Contratacion/views/Contratos/Metas/MetasIndex.vue'
              ),
            icon: 'ClipboardDocumentCheckIcon',
            menu: false,
            desplegable: false,
            meta: {
              title: 'Indicadores de Cumplimiento',
              requiresSession: true,
              perfiles: ['CONTRATACION'],
              permiso: []
            },
            children: []
          }
        ]
      },
      {
        path: '/pacientes',
        name: 'Pacientes',
        desplegable: false,
        icon: 'UserIcon',
        menu: true,
        meta: {
          permiso: [],
          perfiles: ['ADMINISTRACION', 'COORDINADOR ASISTENCIAL'],
          title: 'Pacientes',
          requiresSession: true,
          showBackButton: false
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Pacientes/PacientesIndex.vue'
          )
      },
      {
        path: '/pacientes/view/:cope_id',
        name: 'PacienteView',
        desplegable: false,
        icon: 'UserIcon',
        menu: false,
        meta: {
          permiso: [],
          title: 'Detalle del paciente',
          requiresSession: true
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Pacientes/PacienteView.vue'
          )
      },
      {
        path: '/pacientes/create',
        name: 'PacienteCreate',
        desplegable: false,
        icon: 'UserIcon',
        menu: false,
        meta: {
          permiso: [],
          title: 'Creación de paciente',
          requiresSession: true
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Pacientes/PacientesForm.vue'
          )
      },
      {
        path: '/pacientes/create/:id',
        name: 'PacienteUpdate',
        desplegable: false,
        icon: 'UserIcon',
        menu: false,
        meta: {
          permiso: [],
          title: 'Actualización de datos del paciente',
          requiresSession: true
        },
        children: [],
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Pacientes/PacientesForm.vue'
          )
      },
      {
        path: '/empleados',
        name: 'Empleados',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Empleados/EmpleadosIndex.vue'
          ),
        icon: 'IdentificationIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Empleados',
          requiresSession: true,
          permiso: [],
          perfiles: ['ADMINISTRACION'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/empleados/create',
        name: 'EmpleadosCreate',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Empleados/EmpleadosForm.vue'
          ),
        icon: 'IdentificationIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Registrar empleado',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/empleados/create/:id',
        name: 'EmpleadosUpdate',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Empleados/EmpleadosForm.vue'
          ),
        icon: 'IdentificationIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Actualizar empleado',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/empleados/empleado/:id',
        name: 'EmpleadosDetalle',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Empleados/EmpleadosView.vue'
          ),
        icon: 'IdentificationIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Empleado',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/basededatos',
        name: 'Basededatos',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/BaseDeDatos/BaseDeDatosIndex.vue'
          ),
        icon: 'CircleStackIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Base de datos',
          requiresSession: true,
          permiso: [],
          perfiles: ['ADMINISTRACION'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/basededatos/view/:cobdId',
        name: 'BasededatosDetalle',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/BaseDeDatos/BaseDeDatosView.vue'
          ),
        icon: 'CircleStackIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Base de datos detalle',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/calendario-admin',
        name: 'CalendarioAdmin',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/CalendarioAdmin/CalendarioAdminIndex.vue'
          ),
        icon: 'mdiCalendarMonth',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Calendario Admin.',
          subTitle: 'Gestión de calendario administrativo',
          requiresSession: true,
          permiso: [],
          perfiles: ['ADMINISTRACION'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/automatizacion-alertas',
        name: 'AutomatizacionAlertas',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/AlertasAutomatizaciones/AlertasAutomatizacionIndex.vue'
          ),
        icon: 'mdiCommentAlert',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Automatización Alertas',
          subTitle: '',
          requiresSession: true,
          permiso: [],
          perfiles: ['ADMINISTRACION'],
          showBackButton: false
        },
        children: []
      }
    ]
  }
]
